module.exports = __webpack_public_path__ + "static/media/yunhaobeipinchukouliiucheng.02696796.png";